import React, { useState, useEffect, useCallback } from 'react';
import banner1 from '../../assets/Banner 1.jpeg';
import banner2 from '../../assets/Banner 2.jpeg';
import banner3 from '../../assets/Banner 3.jpeg';

const slides = [banner1, banner2, banner3];

const Hero = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [touchStart, setTouchStart] = useState(null);
    const [touchEnd, setTouchEnd] = useState(null);

    // Minimum swipe distance in pixels
    const minSwipeDistance = 50;

    const prevSlide = useCallback(() => {
        setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    }, []);

    const nextSlide = useCallback(() => {
        setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 4000);
        return () => clearInterval(timer);
    }, [nextSlide]);

    const onTouchStart = (e) => {
        setTouchEnd(null);
        setTouchStart(e.targetTouches[0].clientX);
    };

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX);
    };

    const onTouchEnd = () => {
        if (!touchStart || !touchEnd) return;
        const distance = touchStart - touchEnd;
        const isLeftSwipe = distance > minSwipeDistance;
        const isRightSwipe = distance < -minSwipeDistance;
        
        if (isLeftSwipe) {
            nextSlide();
        } else if (isRightSwipe) {
            prevSlide();
        }
    };

    return (
        <section 
            className="relative w-full aspect-[2560/1286] lg:aspect-auto lg:h-[calc(100vh-4rem)] bg-white overflow-hidden shadow-sm group"
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
        >
            {/* Slides Container */}
            <div className="relative w-full h-full overflow-hidden">
                {slides.map((slide, index) => {
                    const isActive = index === currentIndex;
                    return (
                        <div
                            key={index}
                            className={`absolute inset-0 w-full h-full transition-all duration-1000 ease-in-out transform ${
                                isActive 
                                    ? 'opacity-100 scale-100 pointer-events-auto z-10' 
                                    : 'opacity-0 scale-105 pointer-events-none z-0'
                            }`}
                        >
                            <img
                                src={slide}
                                alt={`Choundeshwari Pat Sanstha Banner ${index + 1}`}
                                className="w-full h-full object-cover"
                            />
                        </div>
                    );
                })}
            </div>

            {/* Slide Navigation Dots */}
            <div className="absolute bottom-2 md:bottom-4 left-1/2 -translate-x-1/2 z-20 flex items-center space-x-2 md:space-x-3">
                {slides.map((_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentIndex(index)}
                        className={`transition-all duration-300 rounded-full ${
                            index === currentIndex
                                ? 'w-4 h-1 md:w-8 md:h-2 bg-secondary'
                                : 'w-1.5 h-1.5 md:w-2.5 md:h-2.5 bg-white/50 hover:bg-white/80'
                        }`}
                        aria-label={`Go to slide ${index + 1}`}
                    />
                ))}
            </div>
        </section>
    );
};

export default Hero;
